import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import moment from "moment"
import { capitalize, isEmpty } from "lodash"
import { UFDate } from "../../../components/Common/Fields/Input"
import { useForm } from "react-hook-form"
import resetIcon from "../../../assets/icons/reset.svg"
import NumberFormat from "../../../utils/numberFormat"
import { useLocation, useNavigate } from "react-router-dom"
import {
  downloadProjectBill,
  fetchProjectBillingReport,
} from "../../../services/finance/finance"
import { useSelector, useDispatch } from "react-redux"
import { setFilter, removeFilter } from "../../../store/actions"
import { createSelector } from "reselect"
import ProjectBillingFilter from "./filter"
import { getTableMinWidth } from "../../../utils/getTblWdt"
import LoadingButton from "../../../components/Common/LoadingButton"

const ProjectSummaryReport = ({ fromDashboard, projectId }) => {
  document.title = "Project Summary | Everise"
  const dispatch = useDispatch()
  const [search, setSearch] = useState("")
  const [fetchedData, setFetchedData] = useState()
  const [page, setPage] = useState(1)
  const [ccNo, setCCNo] = useState("")
  const [type, setType] = useState("")
  const [productNo, setProductNo] = useState("")
  const [financial, setFinancial] = useState(true)
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [company, setCompany] = useState(false)
  const [datefrom, setDatefrom] = useState("")
  const [dateto, setDateto] = useState("")
  const [dataPerPage, setDataPerPage] = useState(5)
  const desimalrange = localStorage.getItem("desimalrange")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)
  const [productData, setProductData] = useState()

  const [isLoading, setIsLoading] = useState(false)

  const [tableTotalWidth, setTableTotalWidth] = useState(0)

  const selectFilterState = state => state.filterReducer
  const filterProperties = createSelector(selectFilterState, filter => ({
    filters: filter.filters,
    filterLoading: filter.loading,
    filterError: filter.error,
  }))

  const { filters, filterLoading, filterError } = useSelector(filterProperties)
  console.log("filtersdata", filters, filterLoading, filterError)

  useEffect(() => {
    if (
      filters?.dateFrom ||
      filters?.dateTo ||
      filters?.productData ||
      filters?.search
    ) {
      setStartDate(filters?.dateFrom || "")
      setEndDate(filters?.dateTo || "")
      setProductData(filters?.productData || "")
      setSearch(filters?.search || "")
      const fetchData = async () => {
        setIsLoading(true)
        const response = await fetchProjectBillingReport({
          params: `${`account_group_id=24`}${`&cc_type=project`}${`&report_type=project_summary_report`}${
            productNo ? `&cost_center_id=${productNo}` : ""
          }${page ? `&page=${page}` : ""}${
            dataPerPage ? `&perPage=${dataPerPage}` : `&perPage=5`
          }${startDate ? `&date_from=${startDate}` : ""}${
            endDate ? `&date_to=${endDate}` : ""
          }`,
        })
        // setFetchedData(response)
        const newData = response?.data || []

        setFetchedData(prev =>
          page > 1 && prev
            ? {
                ...response,
                data: [...(prev.data || []), ...newData],
              }
            : response
        )
        setIsLoading(false)
        setIsLoadingNextPage(response == undefined ? true : false)
        isLoadingRef.current = false
        // ${`&financial=${financial}`}
      }

      fetchData()
    }
  }, [
    filters?.dateFrom,
    filters?.dateTo,
    filters?.productData,
    filters?.search,
    startDate,
    endDate,
  ])

  const { control, watch, reset } = useForm({
    defaultValues: {
      req_date: null,
    },
  })

  const locations = useLocation()
  const crumb = locations?.state?.menuLabel || ""

  const location = useLocation()
  const navigate = useNavigate()
  const { productId, productName } = location.state || {}

  const handlePaginate = page => {
    setPage(page)
  }

  const handleCCChange = id => {
    setCCNo(id)
    setPage(1)
  }

  const handleTypeChange = id => {
    setType(id)
    setPage(1)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleProductChange = data => {
    setProductNo(
      data?.value && typeof data?.value === "object"
        ? data.id
        : data?.value
        ? data?.value
        : ""
    )
    setProductData(data)
    setPage(1)
    if (!data) {
      // Clear location.state
      navigate(location.pathname, { replace: true, state: {} })
    }
    if (data == undefined) {
      dispatch(removeFilter())
    }
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }

  useEffect(() => {
    if (
      filters?.dateFrom ||
      filters?.dateTo ||
      filters?.productData ||
      filters?.search
    )
      return
    const fetchData = async () => {
      setIsLoading(true)
      const response = await fetchProjectBillingReport({
        params: `${`account_group_id=24`}${`&cc_type=project`}${`&report_type=project_summary_report`}${
          productNo ? `&cost_center_id=${productNo}` : ""
        }${page ? `&page=${page}` : ""}${
          dataPerPage ? `&perPage=${dataPerPage}` : `&perPage=5`
        }${startDate ? `&date_from=${startDate}` : ""}${
          endDate ? `&date_to=${endDate}` : ""
        }`,
      })
      // setFetchedData(response)
      const newData = response?.data || []
      setFetchedData(prev =>
        page > 1 && prev
          ? {
              ...response,

              data: [...(prev.data || []), ...newData],
            }
          : response
      )
      setIsLoading(false)
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false
      // ${`&financial=${financial}`}
    }

    // if (
    //   datefrom &&
    //   dateto &&
    //   moment(datefrom).isSameOrBefore(moment(dateto)) &&
    //   productNo
    // ) {
    fetchData()
    // }
  }, [
    type,
    financial,
    ccNo,
    search,
    projectId,
    startDate,
    endDate,
    company,
    page,
    datefrom,
    dateto,
    productNo,
    dataPerPage,
  ])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false)
  const scrollTimeoutRef = useRef(null)

  const loadMoreRef = useRef(null)

  useEffect(() => {
    if (!loadMoreRef.current) return

    const observer = new IntersectionObserver(
      entries => {
        const target = entries[0]

        if (
          target.isIntersecting &&
          !isLoadingRef.current &&
          page < fetchedData?.meta?.last_page
        ) {
          isLoadingRef.current = true
          setIsLoadingNextPage(true)
          setPage(prev => prev + 1)
        }
      },
      { threshold: 1 }
    )

    observer.observe(loadMoreRef.current)

    return () => observer.disconnect()
  }, [fetchedData, page])

  useEffect(() => {
    const handleScroll = e => {
      const { scrollTop, scrollHeight, clientHeight } = e.target

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }

      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < fetchedData?.data?.meta?.last_page
        ) {
          isLoadingRef.current = true
          setIsLoadingNextPage(true)
          setPage(prev => prev + 1)
        }
      }, 200)
    }

    const container = tableContainerRef.current
    if (container) {
      container.addEventListener("scroll", handleScroll)
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll)
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }
    }
  }, [fetchedData, page])

  const getColumnTotal = key => {
    return NumberFormat(
      (fetchedData?.data || []).reduce(
        (sum, row) => sum + Number(row?.[key] || 0),
        0
      ),
      desimalrange,
      desimalrange
    )
  }

  const columns = [
    {
      label: "Project",
      renderCell: item =>
        fromDashboard ? (
          item?.cost_center_name
        ) : (
          <div
            // onClick={() => {
            //   navigate(`/finance-voucher/view/${item?.voucher_entry_id}`, {
            //     state: {
            //       bread: crumb,
            //     },
            //   })
            // }}
            className="fw-bold"
          >
            {" "}
            {item?.cost_center_name}{" "}
          </div>
        ),
      footerContent: () => "Total",
    },
    {
      label: <div className="text-end pe-5">Project Value</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.projectAmount || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
      footerContent: () => (
        <div className="text-end pe-5">{getColumnTotal("projectAmount")}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">Revenue</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.revenue_amount || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
      footerContent: () => (
        <div className="text-end pe-5">{getColumnTotal("revenue_amount")}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">Adv Bal</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.adv_received_group || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("adv_received_group")}
        </div>
      ),
    },

    {
      label: <div className="text-end pe-5">Retention</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.retention_group || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
      footerContent: () => (
        <div className="text-end pe-5">{getColumnTotal("retention_group")}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">DLP</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.dlp_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">{getColumnTotal("dlp_group")}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">Material</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.material_purchase_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("material_purchase_group")}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Sub-Contract</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.sub_contract_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("sub_contract_group")}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Supply Labour Cost</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.manpower_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">{getColumnTotal("manpower_group")}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">Direct Labour Cost</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.wages_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">{getColumnTotal("wages_group")}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">Total Direct Cost</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.total_direct_cost || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("total_direct_cost")}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Contribution</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.contribution_margin || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("contribution_margin")}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Staff Salary</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.staff_salary_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("staff_salary_group")}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Admin & General</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.admin_general_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("admin_general_group")}
        </div>
      ),
    },

    {
      label: <div className="text-end pe-5">Other In-Direct Cost</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.other_indirect_expense_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("other_indirect_expense_group")}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Total In-Direct Cost</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.total_indirect_expense || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("total_indirect_expense")}
        </div>
      ),
    },
    {
      label: <div className="">NP</div>,
      renderCell: item => (
        <>
          <div>{item?.mp ? "True" : "False"}</div>
        </>
      ),
    },
  ]

  const handleRequestdate = data => {
    let fromDate = ""
    let toDate = ""
    console.log(`fromDate 1`, fromDate, toDate)

    fromDate = !isEmpty(data) ? moment(data[0]).format("YYYY-MM-DD") : ""
    toDate = !isEmpty(data) ? moment(data[1]).format("YYYY-MM-DD") : ""
    console.log(`fromDate 2`, fromDate, toDate)
    setStartDate(fromDate)
    setEndDate(toDate)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const handleReset = () => {
    reset({ req_date: null })
    setStartDate("")
    setEndDate("")
  }

  const handleCompanyChange = id => {
    setCompany(id)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    setStartDate(fromdate)
    setEndDate(todate)
    setPage(1)
    setDataPerPage(25)
  }

  const totalAgainstPayment = (voucherEntries = []) => {
    return voucherEntries.reduce((sum, entry) => {
      const innerSum = (entry?.against_payment || []).reduce(
        (acc, ap) => acc + Number(ap?.amount || 0),
        0
      )
      return sum + innerSum
    }, 0)
  }

  const totalNetReceivable = (voucherEntries = []) => {
    return voucherEntries.reduce(
      (sum, entry) => sum + Number(entry?.net_receivable || 0),
      0
    )
  }

  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <Breadcrumbs
                title="Finance"
                breadcrumbObject={[
                  { title: "Finance", link: "/finance" },
                  { title: crumb || "Reports", link: "#" },
                  {
                    title: "Project Summary",
                    link: "#",
                  },
                ]}
              />
            ) : (
              <></>
            )}
            <>
              <div className="me-2">
                <span id={`PopoverLegacy-1`} className="px-2 btn btn-primary">
                  Download
                </span>
              </div>
              <UncontrolledPopover
                placement="bottom"
                target={`PopoverLegacy-1`}
                trigger="legacy"
              >
                <PopoverBody>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadProjectBill({
                        params: `export_format=pdf&account_group_id=24&cc_type=project${`&report_type=project_summary_report`}${
                          productNo ? `&cost_center_id=${productNo}` : ""
                        }${startDate ? `&date_from=${startDate}` : ""}${
                          endDate ? `&date_to=${endDate}` : ""
                        }`,
                        type: "pdf",
                        fileName: "project_summary.pdf",
                      })
                    }
                  >
                    PDF
                  </div>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadProjectBill({
                        params: `export_format=excel&account_group_id=24&cc_type=project${`&report_type=project_summary_report`}${
                          productNo ? `&cost_center_id=${productNo}` : ""
                        }${startDate ? `&date_from=${startDate}` : ""}${
                          endDate ? `&date_to=${endDate}` : ""
                        }`,
                        type: "excel",
                        fileName: "project_summary.xlsx",
                      })
                    }
                  >
                    Excel
                  </div>
                </PopoverBody>
              </UncontrolledPopover>
            </>
          </div>

          <Card
            className={`me-2 px-2 pb-2 ${fromDashboard ? "dash-table-bg" : ""}`}
          >
            {fromDashboard ? (
              <div className="px-2 py-3">Transaction History</div>
            ) : (
              <ProjectBillingFilter
                // handleCCChange={handleCCChange}
                handleTypeChange={handleTypeChange}
                handleSearchChange={handleSearchChange}
                handleDateChange={handleDateChange}
                handleProductChange={handleProductChange}
                handleFinacialChange={handleFinacialChange}
                handleCompanyChange={handleCompanyChange}
                resetData={{
                  fromData: datefrom,
                  toData: dateto,
                  productData: productData,
                  search: search,
                }}
                {...(location?.state && {
                  productId,
                  productName,
                })}
              />
            )}
            <hr className="table-divide" />
            <div>
              {fromDashboard && (
                <Row className="pt-2">
                  <Col sm={6}>
                    <UFDate
                      control={control}
                      placeholder="Date"
                      name={"req_date"}
                      mode="range"
                      className="ufinput-dashboard"
                      onDateChange={e => handleRequestdate(e)}
                    />
                  </Col>
                  <Col sm={3}></Col>
                  <Col sm={3}>
                    <div
                      className="pointer me-2 text-white btn btn-primary float-end"
                      onClick={() => handleReset()}
                    >
                      <img
                        src={resetIcon}
                        height={15}
                        width={15}
                        className="me-2 svg-clr-reset"
                      />{" "}
                      Reset
                    </div>
                  </Col>
                </Row>
              )}
              <Row
                className={`ever-rise-table ${
                  fromDashboard ? "dashboardTable" : ""
                } `}
              >
                <Col xs={12}>
                  {fetchedData?.data?.length ? (
                    <div
                      ref={tableContainerRef}
                      style={{ maxHeight: "490px", overflowY: "auto" }}
                    >
                      {/* {fetchedData?.data?.map((data, i) => (
                        <>
                          <div className="d-flex justify-content-between px-2 py-3 fw-600 cost-center-bar">
                            <div>
                              Cost Center: {data?.cost_center_name || ""}
                            </div>
                            <div>
                              Project Amount:{" "}
                              {NumberFormat(
                                Number(data?.projectAmount || 0),
                                desimalrange,
                                desimalrange
                              )}{" "}
                            </div>
                          </div> */}

                      <UpdateTable
                        className="mt-5"
                        nodes={fetchedData?.data}
                        paginate={fetchedData}
                        columns={columns}
                        CurrentPage={page}
                        handlePagination={handlePaginate}
                        handleSizePerPage={handleSizePerPageChange}
                        tableWidth="30% 20% 15% 15% 15% 15% 15% 15% 15% 15% 15% 15% 15% 15% 15% 15% 10%"
                        mobileWidth="50% 50% 50% 50%"
                        isLoading={isLoadingNextPage}
                        hidePaginate={true}
                        showFooter={true}
                      />
                      {/* <div
                            className="d-flex fw-600 py-2"
                            style={{ minWidth: "259%" }}
                          >
                            <div className="wdt-20 ps-2">Total</div>
                            <div className="wdt-15"></div>
                            <div className="w-30"></div>
                            <div className="wdt-15 ps-4">
                              {data?.VoucherEntries[
                                data?.VoucherEntries?.length - 1
                              ]?.progress || "0%"}
                            </div>
                            <div className="wdt-15 text-end pe-5">
                              {NumberFormat(
                                Number(
                                  data?.VoucherEntries[
                                    data?.VoucherEntries?.length - 1
                                  ]?.progress_amount || 0
                                ),
                                desimalrange,
                                desimalrange
                              )}
                            </div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15 text-end pe-5">
                              {NumberFormat(
                                Number(
                                  totalNetReceivable(data?.VoucherEntries) || 0
                                ),
                                desimalrange,
                                desimalrange
                              )}
                            </div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15 text-end pe-2">
                              {NumberFormat(
                                Number(
                                  totalAgainstPayment(data?.VoucherEntries) || 0
                                ),
                                desimalrange,
                                desimalrange
                              )}
                            </div>
                            <div className="wdt-15 text-end pe-2 text-danger">
                              {NumberFormat(
                                Number(
                                  totalNetReceivable(data?.VoucherEntries) || 0
                                ) -
                                  Number(
                                    totalAgainstPayment(data?.VoucherEntries) ||
                                      0
                                  ),
                                desimalrange,
                                desimalrange
                              )}
                            </div>
                          </div>
                        </>
                      ))} */}
                      {page < fetchedData?.meta?.last_page && (
                        <div
                          className="cost-center-bar d-flex justify-content-center mb-2"
                          // ref={loadMoreRef}
                        >
                          <LoadingButton
                            color="primary"
                            onClick={() => setPage(prev => prev + 1)}
                            loading={isLoading}
                          >
                            Load More
                          </LoadingButton>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="d-flex mt-5 justify-content-center align-items-center fw-bold text-mute">
                      No Data Found
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ProjectSummaryReport
